"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryStringValue = exports.requireArgument = exports.getSessionStorage = exports.setSessionStorage = exports.getLocalStorage = exports.setLocalStorage = exports.FormattedValue = exports.formattedValueToString = exports.longDateFormat = exports.shortDateFormat = exports.shortDateTimeFormat = exports.shortTimeFormat = exports.longTimeFormat = exports.longDateTimeFormat = exports.deepCloneEverything = exports.deepClone = exports.clone = exports.searchDebounceWait = void 0;
const kendo_intl_1 = require("@telerik/kendo-intl");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const locales_1 = require("../locales");
const lz_string_1 = __importDefault(require("lz-string"));
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
exports.searchDebounceWait = 500;
function clone(obj) {
    return lodash_1.default.extend({}, obj);
}
exports.clone = clone;
function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
exports.deepClone = deepClone;
function deepCloneEverything(obj) {
    return lodash_1.default.extend(true, {}, obj);
}
exports.deepCloneEverything = deepCloneEverything;
exports.longDateTimeFormat = {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true
};
exports.longTimeFormat = "T";
exports.shortTimeFormat = "t";
exports.shortDateTimeFormat = {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true
};
exports.shortDateFormat = {
    month: "numeric",
    day: "numeric",
    year: "numeric"
};
exports.longDateFormat = {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric"
};
exports.formattedValueToString = (intl, props) => {
    let { format, value } = props;
    let output = value || "---";
    if (!format || format == "-") {
        return `${output}`;
    }
    value = `${value}`;
    if (format === "D") {
        format = exports.longDateFormat;
    }
    else if (format === "d") {
        format = exports.shortDateFormat;
    }
    if ([
        exports.shortDateFormat,
        exports.longDateFormat,
        exports.shortDateTimeFormat,
        exports.longDateTimeFormat,
        "D",
        "d",
        "F",
        "g",
        "G",
        "M",
        "m",
        "Y",
        "y",
        "t",
        "T",
        "s",
        "u"
    ].find(f => f === format)) {
        output = intl.formatDate(moment_1.default(value).toDate(), format);
    }
    else if (format === "C") {
        output = `${props.currency ||
            kendo_intl_1.localeCurrency(intl.locale || locales_1.defaultLocaleId)} ${intl.formatNumber(parseFloat(value), { style: "decimal" })}`;
    }
    else if (format === "c") {
        output = intl.formatNumber(parseFloat(value) || 0, {
            style: "currency",
            currency: props.currency || kendo_intl_1.localeCurrency(intl.locale || locales_1.defaultLocaleId),
            currencyDisplay: "symbol"
        });
    }
    else if (!isNaN(parseFloat(value))) {
        output =
            format === "p"
                ? intl.formatNumber(parseFloat(value) / 100, "p2")
                : intl.formatNumber(parseFloat(value), format);
    }
    else if (value === null || isNaN(parseFloat(value))) {
        output = "---";
    }
    else if (moment_1.default(value).isValid()) {
        output = intl.formatDate(moment_1.default(value).toDate(), format);
    }
    else if (!output) {
        output = 0;
        output = intl.toString(output, format);
    }
    return `${output}`;
};
exports.FormattedValue = (props) => {
    const { localeId } = props;
    const localeFromContext = locales_1.useLocale();
    const Result = () => {
        const intl = kendo_react_intl_1.useInternationalization();
        var output = exports.formattedValueToString(intl, props);
        return react_1.default.createElement(react_1.default.Fragment, null, `${output}`);
    };
    return (react_1.default.createElement(kendo_react_intl_1.IntlProvider, { locale: localeId || localeFromContext },
        react_1.default.createElement(Result, null)));
};
function setLocalStorage(key, data) {
    var compressed = lz_string_1.default.compressToUTF16(data);
    localStorage.setItem(key, compressed);
}
exports.setLocalStorage = setLocalStorage;
function getLocalStorage(key) {
    return lz_string_1.default.decompressFromUTF16(localStorage.getItem(key) || "");
}
exports.getLocalStorage = getLocalStorage;
function setSessionStorage(key, data) {
    var compressed = lz_string_1.default.compressToUTF16(data);
    sessionStorage.setItem(key, compressed);
}
exports.setSessionStorage = setSessionStorage;
function getSessionStorage(key) {
    return lz_string_1.default.decompressFromUTF16(sessionStorage.getItem(key) || "");
}
exports.getSessionStorage = getSessionStorage;
function requireArgument(args, argumentName) {
    if (args[argumentName] === undefined) {
        throw new Error("Required argument '{0}' was not provided.".format(argumentName));
    }
    return args[argumentName];
}
exports.requireArgument = requireArgument;
function getQueryStringValue(name) {
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(window.location.href);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
exports.getQueryStringValue = getQueryStringValue;
//# sourceMappingURL=core.js.map